import React from 'react';
import Translation from '../../../translation/translation';

function NoneGiven() {
    return (
        <span className="statusbar__current-status">
            <Translation translationKey="catalog-current-status-no-data" />
        </span>
    );
}

export default NoneGiven;